import { anatomyToVector } from "./index6.js";
import { getInnerMuscles } from "./index19.js";
import { Side } from "./index50.js";
import { ThreadData } from "./index54.js";
import { BoneSide, GetAllBones } from "@project-rouge/rg-core";
import { Vector3 } from "three";
function getThreadsFromBuilding(building, context) {
	const bones = GetAllBones(building.data.anatomy);
	const threads = bones.map((b) => getThreadFromBone(b, context));
	for (let i = 0; i < bones.length; i++) {
		const prevBone = bones[i];
		const nextBone = prevBone.joints[1].bones.find((b) => b !== prevBone);
		if (!nextBone) continue;
		const nextIndex = bones.indexOf(nextBone);
		const prevThread = threads[i];
		const nextThread = threads[nextIndex];
		prevThread.endThread = {
			thread: nextThread,
			right: false
		};
		nextThread.startThread = {
			thread: prevThread,
			right: false
		};
	}
	for (let i = 0; i < threads.length; i++) {
		var _prevThread$endThread;
		const prevThread = threads[i];
		const nextThread = (_prevThread$endThread = prevThread.endThread) === null || _prevThread$endThread === void 0 ? void 0 : _prevThread$endThread.thread;
		if (!nextThread) continue;
		nextThread.start.addScaledVector(nextThread.dir, prevThread.depth);
	}
	return threads;
}
function getThreadFromBone(bone, context) {
	let load;
	if (bone.muscles.length === 1) if (bone.muscles[0].side === BoneSide.Left) load = Side.left;
	else load = Side.right;
	const dir = anatomyToVector(bone).normalize();
	const start = new Vector3().fromArray(bone.joints[0].pos);
	const thread = new ThreadData({
		load,
		start,
		dir,
		boundary: [],
		holes: [],
		context,
		plotIndex: -1
	});
	thread.end.fromArray(bone.joints[1].pos);
	const prevBone = bone.joints[0].bones.find((b) => b !== bone);
	const nextBone = bone.joints[1].bones.find((b) => b !== bone);
	if (prevBone) {
		const diff = getInnerMuscles(bone, prevBone)[1] ? context.singleBigSide : context.singleSmallSide;
		thread.start.addScaledVector(thread.dir, -diff);
	}
	if (nextBone) {
		const diff = getInnerMuscles(bone, nextBone)[1] ? context.singleBigSide : context.singleSmallSide;
		thread.end.addScaledVector(thread.dir, diff);
	}
	return thread;
}
export { getThreadsFromBuilding };

//# sourceMappingURL=index68.js.map